var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 13,
    viewBox: "0 0 28 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 1C22.15 4 18.9597 7 14.5 7C10.0403 7 6.85 4 6 1",
    stroke: "#090110",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 4.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 9.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 11.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 4.5,
    r: 1.5,
    fill: "#090110"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeClosed);
export default __webpack_public_path__ + "static/media/icon_eye_closed.6f13a3a262e22d7011cd97b1dfbf6f56.svg";
export { ForwardRef as ReactComponent };